import {
    Button,
    Card,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    Spinner,
  } from "reactstrap";
  
  import { ChangeEvent, useState, useContext } from "react";
  import { AuthContext } from "../context/AuthContext";
  import moment from "moment";
  
  const Register = () => {
    const { empresaRegister } = useContext(AuthContext);
  
    const [empresa, setEmpresa] = useState({
      name: "",
      email: "",
      password: "",
    });
  
    const [loading, setLoading] = useState(false);
  
    const handleRegisterClick = async () => {
      setLoading(true);
      const empresaCreateRequest = {
        ...empresa,
        user: {
          id: 0,
          createdDate: moment().toISOString(),
          updatedDate: moment().toISOString(),
          name: empresa.name,
          email: empresa.email,
          username: empresa.name,
          password: empresa.password,
          type: 1,
          status: 1,
        },
      };
      await empresaRegister(empresaCreateRequest);
      setLoading(false);
    };
  
    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target;
      setEmpresa((prevEmpresa) => ({
        ...prevEmpresa,
        [name]: value,
      }));
    };
  
    return (
      <>
        <Col lg="5" md="7">
          <Card className="shadow-lg border-0 p-4" style={{ borderRadius: "20px", backgroundColor: "#f0f2f5" }}>
            <img
              style={{ width: "63%" }}
              alt="Logo"
              className="rounded-circle mx-auto d-block mt-3 mb-4"
              src={require("../assets/img/brand/logoAtt.png")}
            />
            <div className="px-lg-5">
              <div className="text-center text-muted mb-4">
                <small>Cadastro de Empresa</small>
              </div>
  
              <Form role="form">
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative"><InputGroupText>
                        <i className="ni ni-building" />
                      </InputGroupText><Input
                      name="name"
                      placeholder="Nome da Empresa"
                      type="text"
                      value={empresa.name}
                      onChange={handleInputChange}
                      style={{ backgroundColor: "#fff", borderRadius: "10px" }}
                    />
                  </InputGroup>
                </FormGroup>
  
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative"><InputGroupText>
                        <i className="ni ni-email-83" />
                      </InputGroupText><Input
                      name="email"
                      placeholder="Email"
                      type="email"
                      value={empresa.email}
                      onChange={handleInputChange}
                      style={{ backgroundColor: "#fff", borderRadius: "10px" }}
                    />
                  </InputGroup>
                </FormGroup>
  
                <FormGroup>
                  <InputGroup className="input-group-alternative"><InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText><Input
                      name="password"
                      placeholder="Senha"
                      type="password"
                      value={empresa.password}
                      onChange={handleInputChange}
                      style={{ backgroundColor: "#fff", borderRadius: "10px" }}
                    />
                  </InputGroup>
                </FormGroup>
  
                <div className="text-center">
                  <Button
                    onClick={handleRegisterClick}
                    className="my-4"
                    color="secondary"
                    type="button"
                    disabled={loading}
                    style={{ backgroundColor: "#6c757d", color: "#FFF", borderRadius: "12px" }}
                  >
                    {loading && <Spinner size="sm">Carregando...</Spinner>}
                    {" "}Cadastrar
                  </Button>
                </div>
              </Form>
            </div>
          </Card>
  
          <Row className="mt-3">
            <Col xs="6">
              <a
                className="text-muted"
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/auth/login";
                }}
              >
                <small>Já tem uma conta? Faça login</small>
              </a>
            </Col>
          </Row>
        </Col>
      </>
    );
  };
  
  export default Register;